// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2PpgH","location":"Header_location__27eL2"};